import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'

export class OperatorEditor extends Component {
  constructor ({ variable }) {
    super()
    this.state = {
        selectedFormula: variable.args[0] || '',
        selectedStep: variable.args[1] || variable.args[1] === 0 ? variable.args[1] : ''
    }
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { selectedFormula, selectedStep } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [selectedFormula, selectedStep])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  generateFormulaOptions = () => {
      const { vars } = this.props
      const options = [
          <option key='empty_formula_option' value=''>Select Formula...</option>
      ]

      for (const variableId in vars) {
        const variable = vars[variableId]
        if (variable.macro === 'formula') {
            options.push(
                <option key={`_${variableId}`} value={variableId}>{variable.name}</option>
            )
        }
      }

      return options
  }

  generateStepOptions = () => {
      const { vars } = this.props
      const { selectedFormula } = this.state
      const options = [<option key='_EMPTY_SELECT_' value=''>Select Step...</option>]
      const variable = vars[selectedFormula]
      if (variable) {
          const [ steps ] = variable.args
          for (const [index, step] of steps.entries()) {
              if (step.type === 'operator' && index !== steps.length - 1) {
                  options.push(
                      <option key={index} value={options.length - 1}>{options.length}</option>
                  )
              }
          }
      }


      return options
  }

  handleUpdateSelectedFormula = event => {
      this.setState({
          selectedFormula: event.target.value,
          selectedStep: ''
      })
  }

  handleUpdateSelectedStep = event => {
      this.setState({
          selectedStep: event.target.value
      })
  }

  render () {
    const { selectedFormula, selectedStep } = this.state
    const formulaOptions = this.generateFormulaOptions()
    const stepOptions = this.generateStepOptions()
    return (
      <div className={css.wrapper}>
        <label>Formula</label>
        <div className={css.backer}>
          <select
            className={css.select}
            value={selectedFormula}
            onChange={this.handleUpdateSelectedFormula}
          >
            {formulaOptions}
          </select>
        </div>
        <label>Step</label>
        <div className={css.backer}>
            <select
              className={css.select}
              value={selectedStep}
              onChange={this.handleUpdateSelectedStep}
            >
              {stepOptions}
            </select>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(OperatorEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/OperatorEditor/index.js